import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TosContractsComponent } from './tos-contracts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { SafePipe } from 'src/app/angular-wallet-base/pipes/safe-urls/safe-urls-pipe';
import { SafeUrlsModule } from 'src/app/angular-wallet-base/pipes/safe-urls/safe-urls.module';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        SafeUrlsModule
    ],
    providers: [FileTransfer, File, DocumentViewer],
    declarations: [TosContractsComponent, SafePipe],
    exports: [TosContractsComponent]
})
export class TosContractsModule { }
